var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small"},[_c('ChartPie',{attrs:{"label":_vm.theLabel,"labels":_vm.labels,"data":_vm.data,"colors":_vm.colors,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }